// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Z2YYN","credits":"Footer_credits__xTIDI"};